import { loadOptions } from '../../versa/formset.js';

/** Opções de filtro/form para tipo de Doca de Entrada (#MT-B2FA396). */
export default function (...args)
{
	return {
		options: [
			{ value: 'DRY', label: 'Seca' },
			{ value: 'REFRIGERATED', label: 'Refrigerada' },
			{ value: 'CLIMATE_CONTROLLED', label: 'Climatizada' },
			{ value: 'MIXED', label: 'Mista' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		},
	};
}
